export default function profiles() {
  return [
    'profileGrid',
    'profileDetails',
    'profileCards',
    'profileFeed',
    'groupGrid',
    'groupItem',
    'groupList',
  ];
}



// WEBPACK FOOTER //
// ./src/global-view/editor/page/droplets-tab/site-types/profiles.js